<template>
    <div class="col-xs-12 m-b-30" v-if="ads.length > 0 && show_ads">
        <div class="sponsored_cnt">
            <div class="row">
                <div class="col-xs-12">
                    <p class="pull-left">Anúncios patrocinados por <b>Yuca</b></p>

                    <button @click.prevent="hideAds()" class="btn-link pull-right">Esconder Anúncios</button>
                </div>
            </div>
            <div class="ads-gallery" data-simplebar>
                <div class="simplebar-scroll-content">
                    <div class="simplebar-content">
                        <div class="card" v-for="ad in ads" v-bind:key="ad.id">
                            <a :href="ad.external_url" @click="registerVisit(ad.id)" target="blank_">
                                <div class="photo" :style="{background: photoBackground(ad.main_photo)}">
                                    <span v-if="ad.promotion_tag" class="promotion-tag" :class="ad.promotion_tag.color">
                                        <i :class="ad.promotion_tag.icon"></i>{{ ad.promotion_tag.name }}
                                    </span>
                                </div>
                                <div class="content">
                                    <div class="listingInfo">
                                        <div class="">
                                            <h3 class="text-overflow">{{ ad.title | truncate(40) }}</h3>
                                            <p class="text-muted text-overflow"><i class="fas fa-map-marker-alt m-r-5"></i>{{ ad.location }}</p>
                                            <h5 class="text-success m-t-0">{{ ad.rent_price }} por mês</h5>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['location'],
    data() {
        return {
            show_ads: true,
        }
    },
    computed: {
        ads() {
            return this.$store.getters.getSponsoredAds;
        }
    },
    filters: {
        truncate: function(string, value) {
            if (string.length > value)
                return string.substring(0 , value) + '...';
            else
                return string;
        }
    },
    methods: {
        photoBackground(url) {
            return "url('" + url + "') center center / cover no-repeat";
        },
        hideAds() {
            this.show_ads = false;
        },
        registerVisit(id, index) {
            let data = {
                fk_log: null,
                index: 0,
            }
            axios.post('/property/record-visit/' + id, data);
            window.dataLayer.push({
                'event': 'open-sponsored-ad',
                'event_category': 'search-page',
                'event_label': 'property_ad-' + id,
            });
        }
    },
}
</script>

<style lang="scss" scoped>
    .sponsored_cnt {
        width: 100%;
        background-color: #F7F7F7;
        padding: 20px 20px 10px;
    }

    .promotion-tag {
        padding: 5px 7px;
        border-radius: 3px;
        top: 10px;
        left: 10px;
        position: relative;

        i {
            margin-right: 5px;
        }

        &.danger {
            background-color: #f5707a;
            color: #FFF;
        }

        &.default {
            background-color: #FFF;
            color: #505458;
        }
    }

    .ads-gallery {
        overflow-y: hidden;
        white-space: nowrap;
        position: relative;
        display: inline-block;
        width: 100%;
        height: 275px;
    }

    .card {
        width: 250px;
        display: inline-block;
        margin: 10px 20px 10px 0;
    }

    .photo {
        display: block;
        height: 150px;
        position: relative;
        overflow: hidden;
        border-radius: 3px;
    }

    .content {
		.listingInfo {
			display: block !important;
			width: 100%;
		}

		.listingInfo .price_row h5 {
			display: inline-block;
			margin-bottom: 0;
		}

		.listingInfo h3 {
			margin-bottom: 0;
			white-space: nowrap;
			text-overflow: ellipsis;
			display: block;
			overflow: hidden;
			font-size: 18px;
		}

		.listingInfo .price_line h4 {
			display: inline-block;
			width: auto;
		}

		.listingInfo .line-location {
			text-overflow: ellipsis;
			display: block;
			overflow: hidden;
			white-space: nowrap;
		}

		.description {
			text-overflow: ellipsis;
			max-height: 60px;
			height: 60px;
			display: block;
			overflow: hidden;
		}
	}

</style>
